import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import Select from '../common/form/select';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';

import { setModoTela, initForm } from './usuarioActions';

class UsuarioForm extends Component {

    componentWillMount() {

    }

    render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

		const perfil = this.props.listaPerfil.filter(item => item.id == this.props.formularioValues.id_perfil)[0] || {};

        return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>
							<Field
								name='nome'
								component={LabelAndInput}
								label='Nome *' placeholder='Informe o Nome'
								cols='12 12 12 12'
								readOnly={this.props.alterarSenha ? 'readOnly' : readOnly} />

							<Field
								name='email'
								component={LabelAndInput}
								label='E-mail *'
								placeholder='Informe o E-mail'
								cols='12 12 12 12'
								readOnly={this.props.alterarSenha ? 'readOnly' : readOnly} />

							{!this.props.configuracao && (
								<Field
									name='senha'
									component={LabelAndInput}
									type="password"
									label='Senha *'
									placeholder='Informe a Senha'
									cols='12 12 12 12'
									readOnly={readOnly} />
							)}

							<Select
								name='id_perfil'
								options={this.props.listaPerfil}
								label='Perfil *'
								cols='12 12 12 12'
								placeholder='Selecione o perfil'
								readOnly={(this.props.formularioValues.id && perfil.id_tipo == 2) || this.props.alterarSenha ? 'readOnly' : readOnly}
								value={this.props.formularioValues.id_perfil}
								onChange={value => {
									
									let perfilAtual = this.props.listaPerfil.filter(item => item.id == value)[0] || {};

									this.props.initForm({
										...this.props.formularioValues,
										id_perfil: value,
										id_tipo: perfilAtual.id_tipo,
										id_grupo: null,
										id_cliente: null
									});
								}} />
						</Row>
						{!this.props.formularioValues.id && perfil.id_tipo == 2 /* CLIENTE */ &&	
						<Row>
							<Grid cols='12 12 12 12'>
								<label>Apenas para usuário de cliente</label>
							</Grid>
							
							<Field
								name='id_grupo'
								component={Select}
								options={this.props.listaGrupo}
								label='Região / Grupo'
								cols='12 12 12 12'
								placeholder='Selecione'
								readOnly={readOnly} />
							
							{this.props.formularioValues.id_grupo &&
							<Field
								name='id_cliente'
								component={Select}
								options={this.props.listaCliente.filter(item => item.id_grupo == this.props.formularioValues.id_grupo)}
								label='Cliente'
								cols='12 12 12 12'
								placeholder='Selecione'
								readOnly={readOnly} />}
						</Row>}
						{this.props.formularioValues.id > 0 &&
						<Row>
							{perfil.id_tipo == 2 /* CLIENTE */ &&
							<Field
								name='nome_cliente'
								component={LabelAndInput}
								label='Cliente *' placeholder='Informe o nome'
								cols='12 12 12 12'
								readOnly={'readOnly'} />}

							<Field
								name='inativado'
								component={LabelAndCheckbox}
								label='Inativado' placeholder='Informe'
								cols='12 12 12 12'
								readOnly={this.props.alterarSenha ? 'readOnly' : readOnly} />
						</Row>}
					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.excluir ? (
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
								<Button
									text='Salvar'
									submit
									type={'success'}
									icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => window.confirm('Deseja realmente sair dessa tela?') ? this.props.setModoTela('lista') : null} />
							</Grid>
						</Row>
					</ContentCardFooter>

				</Form>
			</ContentCard>
        )
    }


}

UsuarioForm = reduxForm({form: 'usuarioForm', destroyOnUnmount: false})(UsuarioForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('usuarioForm')(state),
	registro: state.usuario.registro,
	listaPerfil: state.usuario.listaPerfil.filter(item => 
		state.auth.usuarioCarregado
		&& (state.auth.usuarioCarregado.id_perfil == 13 //Administrador Geral
			|| item.id != 13)
		&& (item.departamentos || []).filter(departamento => (state.auth.usuarioCarregado.departamentos || []).includes(departamento)).length
	),
	listaGrupo: state.usuario.listaGrupo,
	listaCliente: state.usuario.listaCliente
});
const mapDispatchToProps = dispatch => bindActionCreators({ setModoTela, initForm }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(UsuarioForm);
